module.exports = "/_next/static/images/hotline-00df855d7070ae5b21e21a17876e4ec7.svg";